import React, { useState } from 'react';
import css from './ContactUsForm.module.css';
import IconCollection from '../../IconCollection/IconCollection';
import Button from '../../Button/Button';
import { Form as FinalForm } from 'react-final-form';
import FieldTextInput from '../../FieldTextInput/FieldTextInput';
import * as validators from '../../../util/validators';
import { supportTeamRequestMessage } from '../../../util/api';
import { FormattedMessage, useIntl } from '../../../util/reactIntl';


export default function ContactUsForm() {
    const intl = useIntl();
    const [status, setStatus] = useState(null);
    const handleSubmit = async (values, form) => {
        setStatus(null);
        try {
            await supportTeamRequestMessage({
                firstName: values.firstName,
                lastName: values.lastName,
                email: values.email,
                description: values.description
            });
            setTimeout(() => form.reset());
            setStatus('sent');
        } catch (e) {
            setStatus('error');
        }
    };

    return (
        <div className={css.contactUsWrapper}>

            <div className={css.formInnerWrapper}>

                <div id='left-form-content'>
                    <div className={css.contentBox}>
                        <h2>
                            <FormattedMessage id="ContactPage.title" />
                        </h2>

                        <p>
                            <FormattedMessage id="ContactPage.intro" />
                        </p>

                        <div className={css.emailBox}>

                            <div className={css.iconNtext}>
                                <IconCollection name={'contactus_email'} />
                                <div>
                                    <p className={css.label}>
                                        <FormattedMessage id="ContactPage.emailLabel" />
                                    </p>
                                    <p className={css.text}>
                                        support@sihmo.com
                                    </p>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div id='right-form-content'>
                    <FinalForm
                        onSubmit={handleSubmit}
                        render={({ handleSubmit: submit, submitting }) => (
                            <form onSubmit={submit}>
                                <div className={css.twoColRow}>
                                    <FieldTextInput
                                        className={css.formRow}
                                        type="text"
                                        id="firstName"
                                        name="firstName"
                                        label={intl.formatMessage({ id: 'ContactPage.firstNameLabel' })}
                                        placeholder={intl.formatMessage({ id: 'ContactPage.firstNamePlaceholder' })}
                                        validate={validators.required(intl.formatMessage({ id: 'ContactPage.firstNameRequired' }))}
                                    />
                                    <FieldTextInput
                                        className={css.formRow}
                                        type="text"
                                        id="lastName"
                                        name="lastName"
                                        label={intl.formatMessage({ id: 'ContactPage.lastNameLabel' })}
                                        placeholder={intl.formatMessage({ id: 'ContactPage.lastNamePlaceholder' })}
                                        validate={validators.required(intl.formatMessage({ id: 'ContactPage.lastNameRequired' }))}
                                    />
                                </div>

                                <FieldTextInput
                                    className={css.formRow}
                                    type="email"
                                    id="email"
                                    name="email"
                                    label={intl.formatMessage({ id: 'ContactPage.emailFieldLabel' })}
                                    placeholder={intl.formatMessage({ id: 'ContactPage.emailPlaceholder' })}
                                    validate={validators.composeValidators(
                                        validators.required(intl.formatMessage({ id: 'ContactPage.emailRequired' })),
                                        validators.emailFormatValid(intl.formatMessage({ id: 'ContactPage.emailInvalid' }))
                                    )}
                                />

                                <FieldTextInput
                                    className={css.formRow}
                                    type="textarea"
                                    id="description"
                                    name="description"
                                    label={intl.formatMessage({ id: 'ContactPage.messageLabel' })}
                                    placeholder={intl.formatMessage({ id: 'ContactPage.messagePlaceholder' })}
                                    validate={validators.required(intl.formatMessage({ id: 'ContactPage.fieldRequired' }))}
                                />

                                {status ? (
                                    <p role="status" style={{ marginTop: 16, color: status === 'sent' ? '#2e7d32' : '#c62828' }}>
                                        <FormattedMessage id={status === 'sent' ? 'ContactPage.sent' : 'ContactPage.sendFailed'} />
                                    </p>
                                ) : null}

                                <div className={css.actionRow}>
                                    <button type="submit" disabled={submitting} className={css.submitButton}><FormattedMessage id="ContactPage.send" /></button>
                                </div>
                            </form>
                        )}
                    />
                </div>

            </div>

        </div>
    )
}


export const GetConnectInput = () => {
    const intl = useIntl();
    return (
        <>
            <div className={css.getConnectInputWrapper}>
                <input placeholder={intl.formatMessage({ id: 'ContactPage.slogan' })} className={css.input} />
                <Button className={css.inputBtn}>
                    <FormattedMessage id="SectionFooter.photographers" />
                </Button>
            </div>
        </>
    )
}
